import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (ALL-5710). This route rendered authored fixtures from data/mock.ts and
// called no API: every service, deployment, user and setting on it was invented, and
// its actions only raised "Local preview only" toasts. It says so plainly until a
// real backend route exists (context/page_pipeline/BOARD.md).
export default function AdminAuthConfigPage() {
  return (
    <DeferredPage
      nav={{ kind: "header", title: "Authentication configuration", subtitle: "Sign-in, MFA and session policy." }}
      state={{
        title: "Authentication configuration is not available in this environment yet",
        description: "Sign-in, MFA and session policy are not read from or written to a live configuration route yet. Enterprise SSO providers are managed under SSO.",
      }}
    />
  );
}
